export default {
    favourites: []
}